import { Flex } from 'antd'
import React from 'react'
import { Outlet } from 'react-router-dom'

export const MainContent: React.FC = () => {
  return (<div style={{flex: 1}}>
    <Flex vertical gap="2.3rem" >
      <Outlet />
    </Flex>
  </div>)
}